import { TooltipNew } from 'ui';
import { AIIcon } from 'ui/icons';

interface CreatedByAiLabelProps {
  createdWithAi: boolean | undefined;
}

export const CreatedByAiLabel = ({ createdWithAi }: CreatedByAiLabelProps) => {
  return (
    <>
      {createdWithAi && (
        <TooltipNew text={'Created by AI'}>
          <div className="flex items-center font-medium text-purple-500 text-[12px]">
            <img alt="logo" src={AIIcon} className="h-[20px] w-[20px] mr-[2px]" /> <span>AI</span>
          </div>
        </TooltipNew>
      )}
    </>
  );
};
